"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var write_generate_themes_exports = {};
__export(write_generate_themes_exports, {
  writeGeneratedThemes: () => writeGeneratedThemes
});
module.exports = __toCommonJS(write_generate_themes_exports);
var fs = __toESM(require("fs-extra"), 1);
async function writeGeneratedThemes(tamaguiDotDir, outPath, generatedOutput) {
  if (!generatedOutput) return;
  var { generated } = generatedOutput;
  if (process.env.DEBUG === "tamagui") {
    console.info(`Generated themes:`, JSON.stringify(generatedOutput, null, 2));
  }
  var newContent = `// @ts-nocheck
` + generated;
  var existingContent = await fs.readFile(outPath, "utf-8").catch(function() {
    return null;
  });
  if (existingContent === newContent) {
    return;
  }
  await fs.writeFile(outPath, newContent);
}
//# sourceMappingURL=write-generate-themes.js.map
